import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UrlService } from '@core/services/url/url.service';
import { Subscription } from 'rxjs';

import * as Objects from '@core/objects';
import { VersionShare, VersionShareListItemMenuClick } from '@core/models/version-share.model';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';

@Component({
    selector: 'core-version-shares',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class CoreVersionSharesMainComponent {

    @Input() versionShareBubbles: Array<VersionShare> = [];
    @Input() user: Objects.User = null; //current user.
    @Input() menu: Array<ThreeDotsMenuItem> = []; // TODO

    @Output() menuClick = new EventEmitter<VersionShareListItemMenuClick>();

    onMenuItemClick(shareMenuItem: VersionShareListItemMenuClick){
        this.menuClick.emit(shareMenuItem);
    }

}
